import { Link, useLoaderData } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { ArticleDto } from '../application/dto/ArticleDto';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import './ArticleListPage.css';

export interface ArticleListLoaderData {
  heading: string;
  basePath: string;
  seoTitle: string;
  seoDescription: string;
  articles: ArticleDto[];
}

function formatDate(iso: string | null): string {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('fa-IR');
}

/**
 * Used for both `/news` and `/articles` — mirrors
 * features/scientific-content/components/ScientificEntryListPage.tsx: the
 * route loader resolves category, heading and URL prefix, this component
 * stays category-agnostic.
 */
export function ArticleListPage() {
  const { heading, basePath, seoTitle, seoDescription, articles } = useLoaderData() as ArticleListLoaderData;
  useDocumentHead({ title: seoTitle, description: seoDescription });

  return (
    <Container>
      <section className="dma-article-list">
        <h1>{heading}</h1>

        {articles.length === 0 ? (
          <p className="dma-article-list__empty">هنوز مطلبی در این بخش منتشر نشده است.</p>
        ) : (
          <div className="dma-article-list__grid">
            {articles.map((article) => (
              <Link key={article.id} to={`${basePath}/${article.slug}`} className="dma-article-list__card">
                {article.coverImage ? (
                  <img src={article.coverImage} alt={article.title} loading="lazy" />
                ) : (
                  <div className="dma-article-list__card-placeholder" aria-hidden="true" />
                )}
                <div className="dma-article-list__card-body">
                  {article.publishedAt ? (
                    <time dateTime={article.publishedAt}>{formatDate(article.publishedAt)}</time>
                  ) : null}
                  <h2>{article.title}</h2>
                  <p>{article.summary}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </Container>
  );
}
